import { IFlowStepWithAnswers } from "../../../types/schema"

export function listFlowTags(steps: IFlowStepWithAnswers[]) {
  const tags: Record<string, boolean> = {}

  steps
    .filter((step): step is IFlowStepWithAnswers & { type: "flowTag" } => step.type === "flowTag")
    .filter(step => step.answer)
    .forEach(step => {
      if (step.answer.action === "add") {
        tags[step.answer.tag] = true
      } else if (step.answer.action === "remove") {
        tags[step.answer.tag] = false
      }
    })

  return Object.keys(tags).filter(tag => tags[tag])
}
